import React, { FC, memo, useEffect, useState } from 'react'
import Routes from './routes'
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from '../../store'
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary'
import Loader from '../../components/Loader'
import ScrollToTop from '../../components/UI/ScrollToTop'
import { getMeThunk } from '../../store/auth/thunks'
import { ToastContainer } from 'react-toastify'
import CustomButton from '../../components/UI/Buttons/CustomButton'

/**
 * App Props Interface
 * @interface AppProps
 */
interface AppProps {}

const App: FC<AppProps> = () => {
  const dispatch = useDispatch();

  const token = localStorage.getItem('token')
  
  const user = useSelector((state) => state.auth.user)

  const [isLoading, setIsLoading] = useState(false);

  // Check if this is an impersonation session (handled by ImpersonationEntry)
  const isImpersonationEntry = window.location.pathname === '/impersonate';

  // check if the user is valid and has token or not during refresh the page
  useEffect(() => {
    const getUserData = async () => {
      setIsLoading(true);
      await dispatch(getMeThunk())
      setIsLoading(false);
    }
    
    // Don't fetch user data if we're on the impersonation entry page
    // (ImpersonationEntry handles this itself)
    if (!user && token && !isImpersonationEntry) {
      getUserData()
    }
  }, [user, dispatch, token, isImpersonationEntry])

  if (isLoading) return <div className='position-absolute top-50 start-50 translate-middle'><Loader /></div>;

  // component for error boundary
  const ErrorFallback = ({ error }: any) => {
    const { resetBoundary } = useErrorBoundary();
  
    return (
      <div role="alert">
        <p>Something went wrong:</p>
        <pre style={{ color: "red" }}>{error.message}</pre>
        <CustomButton variant={'primary'} onClick={resetBoundary}>Try again</CustomButton>
      </div>
    );
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes />
      <ScrollToTop />
      <ToastContainer
        position={"top-right"}
        toastClassName={"custom-toast"}
        hideProgressBar={false}
        limit={1}
        newestOnTop={true}
      />
    </ErrorBoundary>
  )
}
export default memo(App)
